// extracted by mini-css-extract-plugin
module.exports = {"icon":"UserIcon_icon__2GQA8","largeIcon":"UserIcon_largeIcon__2pkyS UserIcon_icon__2GQA8"};